import React from "react";
import { Flag, Gauge, Trophy, CircleDot, ArrowUpRight } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { buildWhatsAppLink } from "@/lib/contact";
import Reveal from "@/components/Reveal";

const sports = [{ key: "golf", Icon: Flag }, { key: "formula1", Icon: Gauge }, { key: "motogp", Icon: Trophy }, { key: "football", Icon: CircleDot }];

export const Events = () => {
  const { t } = useLang();
  return (
    <section id="events" className="section-pad bg-[var(--ms-blue-dark)] text-white" aria-labelledby="events-title">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <Reveal className="lg:col-span-7">
          <span className="ornament">{t.events.overline}</span>
          <h2 id="events-title" className="mt-6 font-serif text-4xl md:text-6xl font-light leading-[1.1]">{t.events.title}</h2>
          <p className="mt-6 text-white/85 text-base md:text-lg leading-relaxed max-w-2xl">{t.events.paragraph}</p>
          <p className="mt-5 text-white/85 text-sm">{t.events.supporting}</p>
          <a href={buildWhatsAppLink(t.events.whatsappMessage)} target="_blank" rel="noopener noreferrer" className="mt-8 inline-flex items-center gap-4 border-b border-[var(--ms-gold)] py-4 text-xs font-semibold tracking-widest uppercase text-[var(--ms-gold)]">{t.events.cta}<ArrowUpRight size={18} className="shrink-0" aria-hidden="true" /></a>
        </Reveal>
        <Reveal delay={150} className="lg:col-span-5">
          <ul className="grid grid-cols-2 gap-x-6 gap-y-8">
            {sports.map(({ key, Icon }) => <li key={key} className="border-t border-white/25 pt-6"><Icon className="text-[var(--ms-gold)] w-7 h-7 mb-4" aria-hidden="true" /><span className="font-serif text-2xl">{t.events.sports[key]}</span></li>)}
          </ul>
        </Reveal>
      </div>
    </section>
  );
};
